import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import {
  donutChartOptions,
  DonutChartOptionsProps,
} from '../../configuration/donut-chart-options';

export type DonutChartProps = {
  data: DonutChartOptionsProps['data'];
  chartTitleText: DonutChartOptionsProps['titleText'];
};

export const DonutChart = (props: DonutChartProps) => {
  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={donutChartOptions({
        data: props.data,
        titleText: props.chartTitleText,
      })}
    />
  );
};
